import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { string, object, func } from 'prop-types';
import Card from '../../../../components/LazyWidgets/Card';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import ReportError from '../ReportError';
import SkillsSummaryTable from '../../../../components/SkillsFeedbackTable/SkillsFeedbackTable';
import s from '../skillsFeedbackSummary/skillsFeedbackSummary.module.css';
import { fetchNotReviewedSummaryReport } from '../../../actions/reports';
import ReportBreadcrumbs from '../../../../components/ReportBreadcrumbs/ReportBreadcrumbs';

class SkillsNotReviewedFeedbackSummary extends Component {
  static propTypes = {
    courseId: string,
    notReviewedFeedbackSummary: object,
    fetchNotReviewedSummaryReport: func,
    onTabChange: func,
    reportTitle: string,
  };

  constructor(props) {
    super(props);

    this.tableStyle = [
      {
        row: 'styledRow',
        cells: [
          { accessor: 'name', alignment: 'left' },
          { accessor: 'numberOfInstructorComments', alignment: 'right' },
          { accessor: 'numberOfStudentReview', alignment: 'right' },
        ],
      },
    ];
  }

  async componentDidMount() {
    const { courseId } = this.props;
    await this.props.fetchNotReviewedSummaryReport(courseId);
  }

  renderNotViewedFeedback() {
    const { reportTitle, notReviewedFeedbackSummary: { data } } = this.props;
    const breadcrumbItems = [
      { text: 'Overview', targetUrl: 'reports' },
      { text: reportTitle }];
    return (
      <div>
        <h3 className={s.titleModule}>{ reportTitle }</h3>
        <ReportBreadcrumbs
          items={breadcrumbItems}
          onTabChange={this.props.onTabChange}
        />
        <Card className={s.summaryCard}>
          <SkillsSummaryTable
            data={data}
            arraySortBy={{ columns: ['numberOfInstructorComments', 'name'], directions: ['desc', 'asc'] }}
            tableStyle={this.tableStyle}
            miniTableDefaultColumn="numberOfInstructorComments"
          />
        </Card>
      </div>
    );
  }
  render() {
    const {
      loading,
      error,
    } = this.props.notReviewedFeedbackSummary;
    if (loading) return <Spinner className={s.spinner} />;
    if (error) return <ReportError />;
    return (
      <div className={s.summaryContainer}>
        {this.renderNotViewedFeedback()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    notReviewedFeedbackSummary: state.reports.skills.notReviewedFeedbackSummary,
    reportTitle: state.reports.skills.notReviewedFeedbackSummary.reportTitle,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchNotReviewedSummaryReport: bindActionCreators(fetchNotReviewedSummaryReport, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SkillsNotReviewedFeedbackSummary);
